module.exports = __webpack_public_path__ + "static/img/appPage_7.e99ba04.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/appPage_7.png
// module id = Myi5
// module chunks = 1